import React from "react";
import LogoutButton from "./LogoutButton";
import "./Header.css";

export default function Header() {
  return (
    <div className="pp-header">
      {/* Left side logos */}
      <div className="pp-header__left">
        <img
          src="/assets/Images/sri-lanka-emblem.png"
          alt="Sri Lanka Emblem"
          className="pp-header__logo"
          onError={(e) => { e.target.style.display = 'none'; }}
        />

        <img
          src="/assets/Images/sludi-logo.png"
          alt="SLUDI Logo"
          className="pp-header__logo"
          onError={(e) => { e.target.style.display = 'none'; }}
        />

        <div className="pp-header__text">
          <h1 className="pp-header__title">
            DEPARTMENT OF IMMIGRATION & EMIGRATION
          </h1>
          <p className="pp-header__subtitle">
            Online Passport Application System
          </p>
        </div>
      </div>

      {/* Right side logos and logout */}
      <div className="pp-header__right">
        <img
          src="/assets/Images/75th-logo.png"
          alt="75th Anniversary"
          className="pp-header__logo pp-header__logo--small"
          onError={(e) => { e.target.style.display = 'none'; }}
        />
        <LogoutButton />
      </div>
    </div>
  );
}